/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BbsContentInfoRespVo } from './BbsContentInfoRespVo';
import {
    BbsContentInfoRespVoFromJSON,
    BbsContentInfoRespVoFromJSONTyped,
    BbsContentInfoRespVoToJSON,
    BbsContentInfoRespVoToJSONTyped,
} from './BbsContentInfoRespVo';

/**
 * 
 * @export
 * @interface PageDataBbsContentInfoRespVo
 */
export interface PageDataBbsContentInfoRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataBbsContentInfoRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataBbsContentInfoRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataBbsContentInfoRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<BbsContentInfoRespVo>}
     * @memberof PageDataBbsContentInfoRespVo
     */
    records?: Array<BbsContentInfoRespVo>;
}

/**
 * Check if a given object implements the PageDataBbsContentInfoRespVo interface.
 */
export function instanceOfPageDataBbsContentInfoRespVo(value: object): value is PageDataBbsContentInfoRespVo {
    return true;
}

export function PageDataBbsContentInfoRespVoFromJSON(json: any): PageDataBbsContentInfoRespVo {
    return PageDataBbsContentInfoRespVoFromJSONTyped(json, false);
}

export function PageDataBbsContentInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataBbsContentInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(BbsContentInfoRespVoFromJSON)),
    };
}

export function PageDataBbsContentInfoRespVoToJSON(json: any): PageDataBbsContentInfoRespVo {
    return PageDataBbsContentInfoRespVoToJSONTyped(json, false);
}

export function PageDataBbsContentInfoRespVoToJSONTyped(value?: PageDataBbsContentInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(BbsContentInfoRespVoToJSON)),
    };
}

